
<template>
    <listing :listing="listing"
             :all-services="allServices"
             :enable-map="enableMap"
             :listing-template-type="listingTemplateType"
             :editable="editable"
             :admin-view="adminView"
             :disable-actions="disableActions"
             :show-detail="showDetail"
             :is-admin="isAdmin"
             :selected-site="selectedSite"
             @open-hours="openHours"
             @open-edit-modal="openEditModal"
             :override-default="overrideDefault">
    </listing>
</template>
<script>
    import script from './ListingTemplateSelectorWrapper';
    export default script;</script>

